import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { analyticsOdfApi } from '../api/analytics-odf.api'
import type {
  ConfiguracionAnalyticsOdfUpdateInput,
  FiltrosReporteOdf,
  TestConnectionInput,
} from '../types'

const KEYS = {
  all: ['analytics-odf'] as const,
  config: () => [...KEYS.all, 'config'] as const,
  overview: (filtros?: FiltrosReporteOdf) => [...KEYS.all, 'overview', filtros] as const,
  medicos: (filtros?: FiltrosReporteOdf) => [...KEYS.all, 'medicos', filtros] as const,
  contenido: (filtros?: FiltrosReporteOdf) => [...KEYS.all, 'contenido', filtros] as const,
}

export function useConfiguracionAnalyticsOdf() {
  return useQuery({
    queryKey: KEYS.config(),
    queryFn: () => analyticsOdfApi.getConfiguracion(),
  })
}

export function useGuardarConfiguracionAnalyticsOdf() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: ConfiguracionAnalyticsOdfUpdateInput) =>
      analyticsOdfApi.saveConfiguracion(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.config() })
    },
  })
}

export function useTestConnectionAnalyticsOdf() {
  return useMutation({
    mutationFn: (payload?: TestConnectionInput) => analyticsOdfApi.testConnection(payload),
  })
}

export function useOverviewAnalyticsOdf(filtros?: FiltrosReporteOdf) {
  return useQuery({
    queryKey: KEYS.overview(filtros),
    queryFn: () => analyticsOdfApi.getOverview(filtros),
  })
}

export function useMedicosAnalyticsOdf(filtros?: FiltrosReporteOdf) {
  return useQuery({
    queryKey: KEYS.medicos(filtros),
    queryFn: () => analyticsOdfApi.getMedicos(filtros),
  })
}

export function useContenidoAnalyticsOdf(filtros?: FiltrosReporteOdf) {
  return useQuery({
    queryKey: KEYS.contenido(filtros),
    queryFn: () => analyticsOdfApi.getContenido(filtros),
  })
}
